import script from "./fish-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./fish-search.vue?vue&type=script&setup=true&lang=ts"

import "./fish-search.vue?vue&type=style&index=0&id=3a490fa3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a490fa3"]])

export default __exports__